import { Component, ElementRef, EventEmitter, Input, NgModule, OnInit, Output, ViewEncapsulation, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

import { AutocompleteRoutingModule } from './autocomplete.routing.module';

declare const $: any;

@Component({
  selector: 'autocomplete',
  template: `
    <div class="md-form form-sm" *ngIf="visible" [ngClass]="{'has-error':error}" [formGroup]="form">
      <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control.value}"></i>
      <input type="search" id="{{name}}" [ngStyle]="{'font-style': (readonly ? 'italic' :'') }" class="form-control mdb-autocomplete"
          [formControl]="control" [attr.length]="length" [ngClass]="{'invalid': error}" [readonly]="readonly" #autocomplete>
      <button class="mdb-autocomplete-clear">
          <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="https://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              <path d="M0 0h24v24H0z" fill="none" />
          </svg>
      </button>
      <label for="{{name}}" [ngClass]="{'active':control.value}">
          <em *ngIf="readonly">{{caption}}</em>
          <b *ngIf="!readonly">{{caption}}</b>
          <span *ngIf="required && !control.value" style="color: red;">
              <b>*</b>
          </span>
      </label>
    </div>
    <span *ngIf="error" class="help-block text-danger" style="font-size: 15px">
      <b>{{ error }}</b>
    </span>`,
  encapsulation: ViewEncapsulation.None
})

export class AutocompleteComponent implements OnInit {
  @ViewChild('autocomplete') autocomplete: ElementRef;
  @Input() public name: string = '';
  @Input() public length: string = '0';
  @Input() public caption: string = '';
  @Input() public readonly: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public enabled: boolean = false;
  @Input() public value: string = '';
  @Input() public glyph: string = '';
  @Output() public valueChange = new EventEmitter<string>();
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public required: boolean = false;
  @Input() public displayCharacterCounter: boolean = true;
  public elementRef: ElementRef;
  @Input() public visible: boolean = true;
  //@Input() public validators: Array<ValidatorFn> = new Array<ValidatorFn>();
  @Input() public pattern: any = null;
  @Input() public patternHint: string = '';
  @Input() public upperCase: boolean = true;
  @Input() public init: boolean = false;
  @Input() public placeholder: string = '';
  @Input() public hiddenNotEmpty: Boolean = false;
  @Input() public title: string = '';
  @Input() public lookFieldName: string;
  @Input() public templateNameList: any;
  @Input() public templateNameRecord: any;
  @Input() public restName: string;
  @Input() public href: string;
  @Input() public id: any;
  @Input() public loading = true;
  @Input() public item: any;
  @Input() public size: any;
  @Input() public filter: string;
  @Output() updated: EventEmitter<any> = new EventEmitter();
  public comp: any = null;
  expanded = false;

  constructor(public itemService: GenericdatasetService, elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit(): void {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }

    //this.updateValidators();
    this.control.valueChanges
      .subscribe((value) => {
        this.load(value);
      });

    /*let states = [
      "Sea Import Shanghai",
      "Sea Export Shanghai",
      "Air Import Shanghai",
      "Air Export Shanghai",
      "Sea Import Ningbo",
      "Sea Export Ningbo",
      "Air Import Ningbo",
      "Air Export Ningbo",
      "Sea Import Tianjin",
      "Air Import Tianjin",
      "Sea Export Tianjin",
      "Air Export Tianjin",
      "Sea Import Shenzhen",
      "Sea Export Shenzhen",
      "Air Import Shenzhen",
      "Air Export Shenzhen"
    ];
    $('.mdb-autocomplete').mdb_autocomplete({
      data: states
    });*/
    //this.load(n);
    this.init = true;
  }

  /*ngOnChanges(change: any) {
    console.log(change);
    if (this.init) {
      if (change.required || change.pattern || change.length) {
        //this.updateValidators();
      }
      this.load();
      console.log(change);
    }
  }*/

  load(value: string) {
    console.log(value)
    if (value) {
      this.loading = true;
      //this.itemService.setrestName(this.restName);
      let columns: any = {columns: [
          { name: 'id', fieldName: 'id', caption: 'id', orderBy: 1, orderByCode: '+', datatype: 0, include: null },
          { name: 'name', fieldName: 'name', caption: 'name', orderBy: 1, orderByCode: '+', datatype: 0, include: null }
        ]};
      this.itemService.setrestName('addresses');
      this.itemService
        .getItems(1, 10, null, columns, value)
        .subscribe(
        (items) => {
          console.log(items)
          const list: string[] = [];
          for (let i = 0; i <= items.length - 1; i++) {
            if (items[i].name) list.push(items[i].name);
          }
          console.log(list);
          //$(this.autocomplete.nativeElement).mdb_autocomplete({
          if (this.comp) $(".mdb-autocomplete").mdb_autocomplete("reset");
          this.comp = $('.mdb-autocomplete').mdb_autocomplete({
            data: list
          });
          //console.log(this.comp)
          //this.item = item;
        },
        (error) => {
          this.error = JSON.parse(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        });
    }
  }
}
